import * as React from "react";
import type { SVGProps } from "react";
const SvgLink2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M15 7V6a1 1 0 0 0-1 1zm3 0V6zm0 10v-1zm-3 0h-1a1 1 0 0 0 1 1zm-6 1a1 1 0 1 0 0-2zm-3-1v-1zm-5-5H0zm5-5V6zm3 1a1 1 0 1 0 0-2zm-1 3a1 1 0 1 0 0 2zm8 2a1 1 0 1 0 0-2zm-1-5h3V6h-3zm3 0a4 4 0 0 1 1.53.304l.766-1.847A6 6 0 0 0 18 6zm1.53.304a4 4 0 0 1 1.298.868l1.415-1.415a6 6 0 0 0-1.947-1.3zm1.298.868c.372.371.666.812.867 1.297l1.848-.765a6 6 0 0 0-1.3-1.947zm.867 1.297A4 4 0 0 1 22 12h2a6 6 0 0 0-.457-2.296zM22 12a4 4 0 0 1-.305 1.53l1.848.766A6 6 0 0 0 24 12zm-.305 1.53a4 4 0 0 1-.867 1.298l1.415 1.415a6 6 0 0 0 1.3-1.947zm-.867 1.298a4 4 0 0 1-1.297.867l.765 1.848a6 6 0 0 0 1.947-1.3zm-1.297.867A4 4 0 0 1 18 16v2a6 6 0 0 0 2.296-.457zM18 16h-3v2h3zm-2 1V7h-2v10zm-7-1H6v2h3zm-3 0a4 4 0 0 1-1.53-.305l-.766 1.848A6 6 0 0 0 6 18zm-1.53-.305a4 4 0 0 1-1.298-.867l-1.415 1.415a6 6 0 0 0 1.947 1.3zm-1.298-.867A4 4 0 0 1 2 12H0a6 6 0 0 0 1.757 4.243zM2 12a4 4 0 0 1 1.172-2.828L1.757 7.757A6 6 0 0 0 0 12zm1.172-2.828A4 4 0 0 1 6 8V6a6 6 0 0 0-4.243 1.757zM6 8h3V6H6zm2 5h8v-2H8z"
    />
  </svg>
);
export default SvgLink2;
